import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { customerApi } from "../lib/customerApi";
import { useCustomerAuth } from "../contexts/CustomerAuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { onPostLogin, refresh } = useCustomerAuth();
    const processedRef = useRef(false);

    useEffect(() => {
        if (processedRef.current) return;
        processedRef.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const next = new URLSearchParams(window.location.search).get("next") || "/";
        if (!match) {
            navigate(next, { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);
        // Clean fragment immediately so the session_id is not retained on history.
        try { window.history.replaceState({}, "", window.location.pathname + window.location.search); } catch (_) { /* ignore */ }

        (async () => {
            try {
                await customerApi.post("/auth/google/session", { session_id: sessionId });
                await refresh();
                await onPostLogin();
                navigate(next, { replace: true });
            } catch (_e) {
                navigate("/login?error=oauth", { replace: true });
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-ivory" data-testid="auth-callback-page">
            <div className="font-serif text-xl text-inkDark">Signing you in…</div>
        </div>
    );
}
